// extracted by mini-css-extract-plugin
export var carrierIcon = "_xc-0";
export var carrierLogo = "_xc-1";
export var detailsSection = "_xc-2";